import { PaymentInterval } from '@/shared/types/Billing';

export const getPlanPeriodLabel = (interval?: PaymentInterval) =>
  interval === PaymentInterval.Year ? 'Annually' : 'Monthly';
